import * as t from 'io-ts';

const undefinedToFalseCodec = new t.Type<boolean>(
  'UndefinedToFalseCodec',
  t.boolean.is,
  (u, c) =>
    t
      .union([t.undefined, t.boolean])
      .validate(u, c)
      .map(x => (typeof x === 'undefined' ? false : x)),
  x => x
);

export default undefinedToFalseCodec;
